import addEditRecord from 'add_edit_modals'

export default ({ personData, onSuccess, onClose }) => {
  const { id, full_name } = personData || {}

  const calendarTaskValues = {
    association_type: 'Person',
    association_id: id,
    association_name: full_name
  }

  addEditRecord({ resourceType: 'calendar_task', values: calendarTaskValues, formMeta: { onSuccess, onClose } })
}
